/**
 * Utility functions for routing configuration
 */

import { ElectronService } from '@app/electron/electron.service';

/**
 * Determines if hash routing should be used based on the environment.
 *
 * Hash routing is needed for Electron when using file:// protocol
 * because there's no server to handle route fallbacks.
 *
 * Regular browser deployments should use standard HTML5 routing
 * for better SEO and cleaner URLs.
 *
 * This function is called during module initialization (before Angular bootstrap),
 * at which point the Electron preload script has already set window.electron if
 * running in Electron.
 */
export function shouldUseHashRouting(): boolean {
  const isElectron = ElectronService.isRunningInElectron();

  // Protocol-based fallback check for extra safety
  // This ensures hash routing is used even if window.electron detection fails
  const isFileProtocol = typeof window !== 'undefined' && window.location?.protocol === 'file:';

  const useHash = isElectron || isFileProtocol;

  // Log only in development for debugging
  if (typeof window !== 'undefined' && !window.location?.hostname?.includes('connectuc')) {
    console.log('[ROUTING] Hash routing configuration:', {
      useHash,
      isElectron,
      isFileProtocol,
      protocol: window.location?.protocol,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      electronVersion: (window as any)?.electron?.versions?.electron,
    });
  }

  return useHash;
}
